import classNames from 'classnames';
import React, { useEffect, useReducer } from 'react';

// TYPES
import { RC_PRELOADER_DEFAULTS, TAssetsLoaderState, TPreloaderState } from './Preloader.types';

// REDUX & MANAGERS
import { SceneNames } from '@Core/SceneNames';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { getGlobalStyles, getPreloaderState } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// CSS
import styles from '@UILayer/UILayer.scss';

//PANELS & VIEWS // MODULES
import PreloaderInfoScreenCheckbox from './Preloader.infoScreenCheckbox';
import IntroMovieActions from './Preloader.introMovieActions';
import PreloaderInfoActions from './Preloader.preloaderInfoActions';
import ProgressBar from './Preloader.progressBar';
import PreloaderSoundCheckbox from './Preloader.soundCheckbox';
import PreloaderWCAMode from './Preloader.wcaMode';

const Prelaoder: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: TPreloaderState, newState: Partial<TPreloaderState>) => ({ ...state, ...newState }), RC_PRELOADER_DEFAULTS);

    const globalStyles = useAppSelector(getGlobalStyles);
    const gameStorePreloaderState = useAppSelector(getPreloaderState);

    const classes = classNames(styles.preloader_container, globalStyles.orientation, state.loaderState === 'COMPLETE' && styles.preloader_completed);

    useEffect(() => {
        EventsCenter.on(EGameEvents.ASSET_LOADER_INFORMATION, (data: Partial<TAssetsLoaderState>) => {
            if (data.loaderState && data.loaderState === 'COMPLETE') {
                setState({ loaderState: data.loaderState });
            }
        });
    }, []);

    useEffect(() => {
        setState({
            currentScene: gameStorePreloaderState.currentScene,
            showIntroMovie: gameStorePreloaderState.showIntroMovie,
            showPreloaderInfo: gameStorePreloaderState.showPreloaderInfo
        });
    }, [gameStorePreloaderState]);

    return (
        <div className={classes}>
            {state.currentScene && (
                <div className={styles.preloader_options}>
                    <PreloaderWCAMode />
                    <PreloaderSoundCheckbox />
                    <PreloaderInfoScreenCheckbox />
                </div>
            )}

            <div className={styles.preloader_actions_container}>
                <div className={styles.preloader_actions_item}>
                    {state.currentScene === SceneNames.INTRO_MOVIE_SCENE && <IntroMovieActions gameStore={gameStorePreloaderState} />}
                    {state.currentScene === SceneNames.PRELOADER_INFO && <PreloaderInfoActions loaderState={state.loaderState} />}
                </div>
                <div className={classNames(styles.preloader_actions_item, styles.preloader_actions_item_checkbox)}></div>
            </div>
            <ProgressBar />
        </div>
    );
};

export default Prelaoder;
